module.exports = __webpack_public_path__ + "img/1.a205fae4.jpg";